const AI_ROUTE = [
  {
    path: 'ai/listing-optimization',
    name: 'ListingOptimization',
    component: () => import('@/views/ai/listing-optimization'),
    meta: {
      title: 'listing优化',
      icon: '',
      keepAlive: true,
    },
  },
  {
    path: 'ai/listing-optimization-detail',
    name: 'ListingOptimizationDetail',
    component: () => import('@/views/ai/listing-optimization/detail'),
    meta: {
      title: 'listing优化详情',
      icon: '',
      keepAlive: false,
    },
  },
]
export default AI_ROUTE
